module.exports = __webpack_public_path__ + "static/img/index-menu-3.a44620ac.png";